
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.95 16l5.65-5.65-1.45-1.45-4.225 4.225-2.1-2.1L3.4 12.45 6.95 16zM2 20c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 010 18V2C0 1.45.196.98.588.587A1.926 1.926 0 012 0h8l6 6v12c0 .55-.196 1.02-.588 1.413A1.926 1.926 0 0114 20H2zM9 7h5L9 2v5z"}})])
          )
        }
      }
    